import { render, staticRenderFns } from "./QuickKeyGrid.vue?vue&type=template&id=cc22b970"
import script from "./QuickKeyGrid.vue?vue&type=script&lang=js"
export * from "./QuickKeyGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports